//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NotificationsList from "./NotificationsAside/NotificationsList";
import Sentinel from '~/components/other/Sentinel'

export default {
  components: {
    Sentinel,
    NotificationsList
  },
  data () {
    return {
      page: 0,
      endReached: false,
      notificationsList: []
    }
  },
  chimera: {
    notifications () {
      return {
        url: `/api/v1/personnel/getMessages/?count=20`,
        key: 'get-messages',
        auto: false,
        params: {
          lang: this.$i18n.locale || 'ru'
        }
      }
    }
  },
  mounted () {
    this.getNext()
  },
  methods: {
    async getNext () {
      this.page = this.page + 1
      const res = await this.$chimera.notifications.send({ page: this.page })
      const { data } = res.data

      if (!data || data.length === 0) {
        this.endReached = true
      } else {
        this.notificationsList = [...this.notificationsList, ...(res.data.data || [])]
      }
    }
  }
}
